module.exports = __webpack_public_path__ + "img/button-music-off.b2a8de8e.svg";